import { Box, Button, CircularProgress, Typography } from '@mui/material'
import React from 'react'

import { ContentFile } from '../../services/api'

interface EditorDocumentPaneProps {
  currentChapter: ContentFile | null
  chaptersCount: number
  onCreateChapter: () => void
  children: React.ReactNode
  /** Optional slot rendered at the very top of the column (above all conditional content). */
  topSlot?: React.ReactNode
  /** Render children even when no chapter is selected (e.g. the continuous all-sections view). */
  forceContent?: boolean
}

export default function EditorDocumentPane({
  currentChapter,
  chaptersCount,
  onCreateChapter,
  children,
  topSlot,
  forceContent = false,
}: EditorDocumentPaneProps) {
  return (
    <Box
      sx={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        minWidth: 0,
        bgcolor: 'var(--bg-app)',
      }}
    >
      {topSlot}
      {currentChapter || forceContent ? (
        children
      ) : chaptersCount > 0 ? (
        <Box
          sx={{
            p: 4,
            textAlign: 'center',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            color: 'var(--text-secondary)',
            gap: 2,
          }}
        >
          <CircularProgress size={28} />
          <Typography sx={{ fontSize: '0.95rem', color: 'var(--text-secondary)' }}>Opening chapter...</Typography>
        </Box>
      ) : (
        <Box
          sx={{
            p: 4,
            textAlign: 'center',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            color: 'grey.600',
          }}
        >
          <Typography variant="h6" gutterBottom sx={{ fontWeight: 400, color: 'grey.700' }}>
            No chapter selected
          </Typography>
          <Typography color="grey.500" sx={{ mb: 3, fontSize: '0.9rem' }}>
            Select a chapter from the sidebar or create a new one to start writing.
          </Typography>
          <Button
            variant="outlined"
            onClick={onCreateChapter}
            sx={{
              maxWidth: 200,
              mx: 'auto',
              borderColor: 'grey.300',
              color: 'grey.700',
              '&:hover': {
                borderColor: 'grey.400',
                bgcolor: 'grey.50',
              },
            }}
          >
            Create New Chapter
          </Button>
        </Box>
      )}
    </Box>
  )
}
